window._theme = window._theme || {};
document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("blogSearch");
    const blogPosts = document.querySelectorAll(".blog-post");
    const searchResult = document.querySelector(".search-result");
    const searchQuerySpan = document.getElementById("searchQuery");
    const searchCountSpan = document.getElementById("searchCount");
    const searchResultText = document.getElementById("search-result-text");
    const loadMoreTrigger = document.getElementById("loadMoreTrigger");
    let visibleCount = 6;
    const loadAmount = 6;
    
    function searchBlog() {
        const query = searchInput.value.trim().toLowerCase();
        
        if (!query) {
            searchQuerySpan.textContent = "";
            searchCountSpan.textContent = "";
            searchResultText.textContent = '';
            blogPosts.forEach(post => post.style.display = "block"); // Show all posts when search is cleared
            return;
        }
    
        let matchCount = 0;
        
        blogPosts.forEach(post => {
            const title = post.getAttribute("data-title").toLowerCase();
            const tags = post.getAttribute("data-tags").toLowerCase();
            const matches = title.includes(query) || tags.includes(query);
            
            post.style.display = matches ? "block" : "none";
            if (matches) matchCount++;
        });
        
        searchResultText.textContent = 'Showing articles that mention';
        searchQuerySpan.textContent = `'${query}': `;
        searchCountSpan.textContent = matchCount || '';
    }    

    function loadMorePosts() {
        const hiddenPosts = Array.from(blogPosts).slice(visibleCount, visibleCount + loadAmount);
        
        hiddenPosts.forEach(post => post.style.display = "block");
        visibleCount += hiddenPosts.length;

        if (visibleCount >= blogPosts.length) {
            observer.disconnect();
            loadMoreTrigger.style.display = "none";
        }
    }
    
    const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
            _theme.toggleLoading(1);
            setTimeout(function(){
                loadMorePosts();
                _theme.toggleLoading(0);
            }, 1000);
        }
    });

    observer.observe(loadMoreTrigger);
    searchInput.addEventListener("input", searchBlog);
});
